import Vue from 'vue'

/**
 * 新闻发布时间格式化
 * @param  {} value
 * @param  {Boolean} showMins=false， n小时之前是否显示分钟
 */
Vue.filter('formatLatelyTime', (value, showMins = false) => {
  let pubTimestamp = value
  if (`${pubTimestamp}`.length < 13) {
    pubTimestamp = value * 1000
  }
  const now = new Date().getTime()
  const timeDis = (now - pubTimestamp) / 1000
  if (timeDis <= 3600) {
    const mins = Math.floor(timeDis / 60) || 1
    return `${mins}${Vue.t(mins > 1 ? 'mins-ago' : 'min-ago')}`
  } else if (timeDis <= 86400) {
    const hours = Math.floor(timeDis / 3600)
    if (showMins) {
      const leftSec = Math.floor(timeDis % 3600)
      const leftMins = Math.floor(leftSec / 60)
      const hour = `${hours}${Vue.t(hours > 1 ? 'hours' : 'hour')}`
      const mins = `${leftMins}${Vue.t(leftMins > 1 ? 'mins-ago' : 'min-ago')}`
      return hour + mins
    } else {
      return `${hours}${Vue.t(hours > 1 ? 'hours-ago' : 'hour-ago')}`
    }
  } else {
    const pubYear = new Date(pubTimestamp).getFullYear()
    const thisYear = new Date().getFullYear()
    // 今年不显示年份
    if (pubYear === thisYear) {
      return Vue.filter('formatDate')(pubTimestamp, showMins ? '3-4' : '3')
    }
    return Vue.filter('formatDate')(pubTimestamp, showMins ? '1-4' : '1')
  }
})
